import script from "./OrderInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfoModal.vue?vue&type=style&index=0&id=2d4c6cb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4c6cb0"]])

export default __exports__